import React, { Fragment, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import Swal from "sweetalert2";

const MenuUploadFrontScreen = ({ param }) => {
  const route = useNavigate();

  return (
    <>
      <div className="max-w-7xl mx-auto px-0 sm:px-6 md:px-8">
        <div className="py-4 border-0 border-dashed sm:p-3 max-h-screen mb-5">
          <div className="border-0 text-center grid grid-cols-1 justify-items-center">
            <div className="border-0 w-full rounded-2xl   sm:shadow-gray-500 grid grid-cols-1 gap-5 sm:gap-5 px-10 py-5">
              <div className="border-0 col-span-1">
                <div className="w-full border-0 grid grid-cols-1 justify-items-center">
                  <img
                    src={require("../../components/assets/images/id-front.png")}
                    className="w-32 sm:w-48"
                  />
                </div>
              </div>
              <div className="border-0 col-span-1 text-2xl font-bold">
                Sube tu documento de identidad
              </div>
              <div className="border-0 col-span-1 text-xl">
                Captura una foto de la parte de atrás
              </div>
              <div className="border-0 col-span-1">
                <button
                  className="bg-Secondary px-4  w-96 py-2 rounded-xl text-white "
                  onClick={() => {}}
                >
                  Toma una foto
                </button>
              </div>
              {/* <div className="border-0 col-span-1">
                <div className="border-0 bg-Secondary  w-96 py-2 rounded-xl cursor-pointer hover:shadow-Secondary/50">
                  <input
                    type={"file"}
                    className="border-0 w-full file:w-full text-transparent file:bg-transparent file:border-0 file:text-transparent absolute"
                  />
                  <div className="text-white text-md">Elige de la galería</div>
                </div>
              </div> */}
              <div className="border-0 col-span-1 grid items-center justify-center">
                <div className="w-72 sm:w-96">
                  <button
                    className="bg-primary px-4 w-96 py-1 rounded-xl text-white hover:shadow-lg hover:shadow-primary/50"
                    onClick={() => {
                      route("/MenuUploadBackScreen");
                    }}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </>
  );
};

export default MenuUploadFrontScreen;
